"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClient = void 0;
const axios_1 = require("axios");
const credentials_1 = require("../credentials");
class ApiClient {
    constructor(baseURL, credentials) {
        /**
         * Performs the authentication if needed
         */
        this.auth = async () => {
            var _a;
            if (((_a = this.credentials) === null || _a === void 0 ? void 0 : _a.type) === 'keycloak') {
                if (!this.credentials.token) {
                    this.credentials.token = (await axios_1.default.post(`${this.credentials.kcUrl}/auth/realms/${this.credentials.realm || credentials_1.DEFAULT_REALM}/protocol/openid-connect/token`, `grant_type=password&client_id=${this.credentials.client_id || credentials_1.DEFAULT_CLIENT_ID}&username=${this.credentials.username}&password=${this.credentials.password}`)).data.access_token;
                }
                return axios_1.default.create({
                    baseURL: this.baseURL,
                    headers: { Authorization: `Bearer ${this.credentials.token}` },
                });
            }
            // TODO: implement basic authentication
            return this.api;
        };
        this.api = axios_1.default.create({ baseURL: baseURL });
        this.credentials = credentials;
        this.baseURL = baseURL;
    }
    async post(url, data, config) {
        return (await this.auth()).post(url, data, config);
    }
    async put(url, data, config) {
        return (await this.auth()).put(url, data, config);
    }
    async delete(url, config) {
        return (await this.auth()).delete(url, config);
    }
    async get(url, configOrAuth, auth = true) {
        if (configOrAuth === undefined) {
            // only one parameter
            return (auth ? await this.auth() : this.api).get(url);
        }
        if (typeof configOrAuth === 'boolean') {
            return configOrAuth ? (await this.auth()).get(url) : this.api.get(url);
        }
        return (auth ? await this.auth() : this.api).get(url, configOrAuth);
    }
}
exports.ApiClient = ApiClient;
//# sourceMappingURL=ApiClient.js.map